import React from 'react';
import { createRoot } from 'react-dom/client';

import dayjs from 'dayjs';
import relativeTime from "dayjs/plugin/relativeTime";
import 'dayjs/locale/fr';

dayjs.extend(relativeTime);
dayjs.locale('fr'); // TODO: Change this based off the user's locale later.

import i18n from '../i18n'; // needed to use i18next instance apparently

import Layout from './layout';

import Sentry from '../sentryConfig'; // See https://deepsy.sentry.io

const container = document.getElementById('app');
if (container) {
    const root = createRoot(container);
    root.render(<Layout />);
};